import { combineReducers } from "redux";
import AuthenticationReducer from "../authentication/reducers";

export default combineReducers({
    AuthenticationReducer
})